import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";
import { trackEvent } from "../../../shared/lib/analytics";

export function useUpdatePlantaoStatusMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.updateStatus,
    onSuccess: (_, { acao }) => {
      // "1º recebido" é um passo do funil de ativação; NF emitida não é medida.
      if (acao === "marcar_recebido") trackEvent("plantao_marcado_recebido");
      invalidateShiftQueries(queryClient);
    },
  });
}
